import { Reducer } from "redux";
import { STASH_PAGE_STATE, StashPageStateAction, UNSTASH_PAGE_STATE, UnstashPageStateAction } from "@/actions/pageStash";


type ActionTypes = 
  | StashPageStateAction
  | UnstashPageStateAction
  ;


export const pageStateStashReducer: Reducer<any, ActionTypes> = (
  previousState = {},
  action
) => {
  switch (action.type) {

    case STASH_PAGE_STATE: {
      return {...previousState,
        [action.payload.path]: action.payload.states,
      }
    }
    case UNSTASH_PAGE_STATE: {
      const newStates = {...previousState}
      delete newStates[action.path]
      return newStates
    }
    default:
      return previousState
    }
}


export const getStashedPageState = (path:string) => (state:any) => 
  state.od.pageStash ? state.od.pageStash[path] : undefined;

